// eslint-disable-next-line no-unused-vars
import {
  isUatEnv as uat,
  isDevEnv as dev,
  isProdEnv as prod,
  isUatIntranetEnv as uatIntranet,
  isProdIntranetEnv as prodIntranet,
  researchCDN,
} from "lib/routing";

export const features = {
  ShareSusbscriptionLink: dev || uat || prod,
  subscriptionButton: dev || uat || prod,
  analytics: dev || uat || prod,
  bannerLandingPages: dev || uat || prod,
  devTools: dev || uat,
  disclosures: dev || uat || prod,
  bannersById: dev || uat || prod,
  alternativeTabbedHomePage: dev || uat,
  podcasts: dev || uat,
  isBulletin: true,
  reportLanguageInAutocomplete: dev || uat || prod,
  dedupAutoCompleteSuggestions: dev || uat || prod,
  economicForecast: dev || uat || prod,
  eventCalendar: dev || uat,
  useContentAPIForAdverts: dev || uat || prod,
  useContentAPIForAdvertStyles: dev || uat || prod,
  useInlineAdvertStyles: false,
  sortAdsByRunningOrder: dev || uat || prod,
  sortFaqBySortField: dev || uat || prod,
  events: dev || uat || prod,
  eventFilters: {
    showLocationFilters: false,
    showLanguageFilters: dev || uat || prod,
    showThemeFilters: dev || uat || prod,
  },
  autocompleteKeywordSuggestions: dev || uat || prod || researchCDN,
  showSearchTooltip: dev || uat || prod,
  analystSubscriptions: dev || uat || prod,
  useContentApiForPages: {
    faq: dev || uat || prod,
    Noteworthy: dev || uat || prod,
    Noteworthy2: false,
    Geopolitics_In_Focus: dev || uat || prod,
    Geopolitics: false,
    Higher_material_and_fuel_prices: dev || uat || prod,
    Economic_Forecast: false,
    Login_terms: dev || uat || prod,
  },
  useJsApiFor: {
    "noteworthy.htm": false,
    "cpi-table.htm": dev,
    "WAAG_2021new.htm": dev,
  },
  contextMenu: {
    backIssues: dev,
    relatedReports: dev,
    fromSameAuthor: dev,
    analystBiography: dev,
    downloadPdf: dev || uat || prod,
    copyText: dev || uatIntranet || prodIntranet,
  },
  econDashboard: {
    fx: dev || uat || prod,
    equity: dev || uat || prod,
    macroStrategy: dev || uat || prod,
    newLabels: dev || uat || prod,
  },
  preview: {
    faq: dev || uatIntranet || prodIntranet,
    disclaimer: dev || uatIntranet || prodIntranet,
    banners: dev || uatIntranet || prodIntranet,
    landingPages: dev || uatIntranet || prodIntranet,
  },
  chatbot: {
    showChatIcon: dev || uatIntranet || prodIntranet,
    showThemeToggle: false,
    showEqCheckbox: dev || uat || prod || researchCDN,
    showAiSummaryButton: dev || uatIntranet || prodIntranet || researchCDN,
    showChatHistory: !researchCDN,  // disabled on researchCDN, enabled elsewhere
    jpUsers: dev || uatIntranet
  },
  showGRPSurveyInvitation: dev || uat,
  serviceNotifications: dev || uat || prod,
  themesFilter: dev || uat || prod,
  isMagicLinkVisible: dev || uat || prod,
  isfeaturedResearchVisible: dev || uat || prod,
};
